// extracted by mini-css-extract-plugin
export default {"tho":"Hopmenh_tho__mSVoW","kim":"Hopmenh_kim__VdsXZ","hoa":"Hopmenh_hoa__E4WQf","moc":"Hopmenh_moc__2mofA","thuy":"Hopmenh_thuy__LviAU","bgr-img":"Hopmenh_bgr-img__+-bLq"};